import { Box, Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const leftSectionWidth = '400px';

export const ReturnToolHeaderStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    height: ${theme.componentStyles.pageHeaderHeight};
    font-size: calc(${theme.spacings[450]} + ${theme.spacings[100]});
    background-color: ${theme.colors.blue[100]};
    width: 100%;
  `}
`;
export const ReturnListSectionStyled = styled.div`
  width: ${leftSectionWidth};
`;

export const HeadingStyled = styled(Text).attrs({
  size: '400',
  color: 'grey.1000',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;
